import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';

export const sentryConfig = {
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  enabled: environment.sentry.enabled,

  // Sends default PII (for example automatic IP collection on events) when true.
  sendDefaultPii: true,

  // Performance monitoring
  tracesSampleRate: 0.1,

  // Session replay (optional)
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,

  // Additional configuration
  integrations: [
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
  ],
  // Enable logs to be sent to Sentry if "dsn" is set (dsn set = sentry enabled) - this is to avoid sending logs to Sentry in local development
  enableLogs: !!environment.sentry.dsn,

  tracePropagationTargets: [
    /^https:\/\/api\.(?:[a-z0-9-]+\.)?sokin\.com$/,
    /^https:\/\/onboard-api\.sokin\.com$/,
  ],

  // Before send hook to filter out certain errors
  beforeSend(event: Sentry.ErrorEvent) {
    // Filter out certain errors if needed
    if (event.exception) {
      const exception = event.exception.values?.[0];
      if (exception?.type === 'ChunkLoadError') {
        return null; // Don't send chunk load errors
      }
    }
    return event;
  },

  // Add user context when available
  beforeBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
    // Add custom breadcrumbs if needed
    return breadcrumb;
  },
};
